export const PRELOAD_WIDGETS_COUNT: number = 0;

export enum ConstructorPageType {
  mainPage = 1,
  bonusCard = 2,
  basket = 3,
  barClub = 5, // Экран "Лента-бар"
  profile = 6,
  action = 7,
  landing = 999,
}
